import React from 'react'
import { MessagingView } from '../code/enums/Enums';
import AuthAdminUserModel from '../code/models/AuthAdminUserModel';
import Customer from '../code/models/Customer';
import MessagingAddLog from './MessagingAddLog';
import MessagingSendEmail from './MessagingSendEmail';
import MessagingTabControl from './MessagingTabControl';
import MessageLogDataTable from "./MessageLogDataTable";

interface ICustomerMessagingForm {
  currentUser: AuthAdminUserModel;
  customer: Customer;
}

export default function CustomerMessagingForm({ currentUser, customer }: ICustomerMessagingForm) {

  const [selectedView, setSelectedView] = React.useState<MessagingView>(MessagingView.Log);

  function onSelectedViewChange(view: MessagingView) {
    setSelectedView(view);
  }

  return (
    <React.Fragment>
      <MessagingTabControl selectedView={selectedView} selectedViewChange={onSelectedViewChange} />
      {selectedView === MessagingView.Log && <MessageLogDataTable currentUser={currentUser} customerId={customer.customerId} />}
      {selectedView === MessagingView.Add && <MessagingAddLog currentUser={currentUser} customer={customer} />}
      {selectedView === MessagingView.Email && <MessagingSendEmail currentUser={currentUser} customer={customer} />}
    </React.Fragment>
  )
}
